module.exports = __webpack_public_path__ + "img/Plantare_RENDER_300x300_SX.bcb63038.png";